import * as React from 'react';
import { Button, SystemMessage } from 'vet-bones/design-system/components';

import styles from 'src/components/resourceDialog/styles/sidebarFooterButtons.module.scss';

export type SidebarFooterButtonsProps = {
  isDirty: boolean;
  onRevert: () => void;
  onSave: () => void;
  isSaveDisabled?: boolean;
  warningText?: string;
  revertLabel: string;
  saveLabel: string;
};

export const SidebarFooterButtons: React.VFC<SidebarFooterButtonsProps> = ({
  isDirty,
  onRevert,
  onSave,
  isSaveDisabled = false,
  warningText,
  revertLabel,
  saveLabel,
}) => {
  return (
    <>
      {warningText ? (
        <div className={styles.footerWarning}>
          <SystemMessage text={warningText} variant="alert" />
        </div>
      ) : null}
      <div className={styles.footerButtons}>
        <Button
          disabled={!isDirty}
          onClick={onRevert}
          size="md"
          variant="tertiary-gray"
        >
          {revertLabel}
        </Button>
        <Button
          disabled={!isDirty || isSaveDisabled}
          onClick={onSave}
          size="md"
          variant="primary-accent"
        >
          {saveLabel}
        </Button>
      </div>
    </>
  );
};
